import useFeatureClientState from "src/shared/utilities/state/apollo/hooks/useFeatureClientState";

import entry from "../../constants/feature";

export default useFeatureClientState(entry);
